<template>
  <div>
    <v-container>

      <!-- ALERT BANNERS (These are already in their own v-row) -->
      <fc-alert-banners v-if='wo' :wo='wo'></fc-alert-banners>
      <v-row>
        <v-col cols="12">
          <v-btn block depressed color='warning' :disabled='wo.is_complete || wo.arrived' @click='notifyArrival()'>
            Notify Arrival
          </v-btn>
        </v-col>
      </v-row>
      <v-row>

        <!-- WORK REQUIRED / TOS BOX (always shown, but with different data)-->
        <v-col cols='12'>
          <wc-data-box dark :color='woType.color' :title='woType.name'>
            <!-- we can reinsert this when irrigaiton tiers are revamped and tos is calculated properly. -->
            <!--  <template v-slot:toolbarButtons>
              <span class='caption'>{{ 'TOS: ' + wo.tos }}</span>
            </template> -->
            <v-simple-table outlined dense>
              <thead></thead>
              <tbody>
                <tr v-for='(item, count) in woData' :key='count'>
                  <td>
                    <span class='font-weight-bold text-left' :class='item.class' v-html='item.text'></span>
                    <span class='pt-2 px-2' v-html='item.value'></span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </wc-data-box>
        </v-col>

        <!-- SITE DETAILS -->
        <v-col cols='12' v-if="woType.category === 'SV' || woType.category === 'SU' || woType.category === 'BD'">
          <wc-data-box title='Site Details' :titleIcon='$store.state.icons.dataBox.details.icon'
            :titleIconColor='$store.state.icons.dataBox.details.color'>
            <template v-slot:toolbarButtons>
              <v-btn small depressed color='primary' width='76px' @click='showDetails = !showDetails'>
                <v-icon x-small class='mr-1'>{{ showDetails ? 'mdi-arrow-expand-up' : 'mdi-arrow-expand-down'
                }}</v-icon>
                {{ showDetails ? 'Hide' : 'Show' }}
              </v-btn>
            </template>
            <v-simple-table outlined dense v-if='showDetails'>
              <tbody>
                <tr v-for="detail in siteDetails" :key='detail.text'>
                  <td>
                    <span class='font-weight-bold text-left text-no-wrap' :class='detail.class'>{{ detail.text }}</span>
                    <span class='pt-2 px-2' v-html='detail.value'></span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </wc-data-box>
        </v-col>

        <!-- OUTSTANDING SERVICE -->
        <v-col cols='12' v-if="woType.category === 'BD' || woType.category === 'SU' || woType.category === 'SV'">
          <outstanding-service v-if='wo.project' :project='wo.project_obj' fieldcrew></outstanding-service>
        </v-col>

        <!-- PRODUCT PICKER -->
        <v-col cols='12' v-if="showProductPicker">
          <fc-product v-if='wo' :wo='wo' :product='product' :productList='productList'
            @updateProduct='updateProduct'></fc-product>
        </v-col>

        <!-- LABOUR PICKER -->
        <v-col cols='12' v-if="showLabourPicker">
          <fc-labour v-if='wo' :wo='wo' :labour='labour' @updateLabour='updateLabour'
            @deleteLabour='deleteLabour'></fc-labour>
        </v-col>

        <!-- STICKY NOTES -->
        <v-col cols='12'>
          <fc-stickies ref='stickies' v-if='wo && (wo.project || wo.estimate)' :wo='wo'></fc-stickies>
        </v-col>

        <v-col cols='12' v-if='woType.category === "IN"'>
          <wc-data-box title='Install Form' titleIcon='v-form-select' :titleIconColor='woType.color'
            :loading='isLoading'>
            <v-form v-model='form_valid' ref='form'>
              <div style='padding-left: 20px; padding-right: 20px;'>
                <v-row>
                  <v-col cols='12'>
                    <div style='background-color: #FFF3CD; border: 1px solid #FFC107; border-radius: 4px; padding: 10px 14px; display: flex; align-items: center; gap: 8px;'>
                      <v-icon color='#856404' small>mdi-alert-circle-outline</v-icon>
                      <span style='color: #856404; font-weight: 600; font-size: 14px;'>Note: Please ensure that every field in this form is completed.</span>
                    </div>
                  </v-col>
                  <v-col cols='6'>
                    <v-text-field :value='woCopy ? woCopy.asbuilt_completed_by : ""'
                      @input='woCopy.asbuilt_completed_by = $event; changes = true;' label='Completed By'
                      :rules='[rules.required]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='6'>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_1802 >= 0 ? woCopy.num_1802 : ""'
                      @input='woCopy.num_1802 = Number($event); changes = true;' label='# of 1802s'
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_1812 >= 0 ? woCopy.num_1812 : ""'
                      @input='woCopy.num_1812 = Number($event); changes = true;' label='# of 1812s'
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='2'></v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy && woCopy.num_shrubrisers >= 0 ? woCopy.num_shrubrisers : ""'
                      @input='woCopy.num_shrubrisers = Number($event); changes = true;' label="# shrubrisers"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_1804 >= 0 ? woCopy.num_1804 : ""'
                      @input='woCopy.num_1804 = Number($event); changes = true;' label="# of 1804s"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_1804_SAM >= 0 ? woCopy.num_1804_SAM : ""'
                      @input='woCopy.num_1804_SAM = Number($event); changes = true;' label='# of 1804 SAMs'
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='2'></v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy && woCopy.num_shrubblers >= 0 ? woCopy.num_shrubblers : ""'
                      @input='woCopy.num_shrubblers = Number($event); changes = true;' label="# shrubblers"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_3504 >= 0 ? woCopy.num_3504 : ""'
                      @input='woCopy.num_3504 = Number($event); changes = true;' label="# of 3504s"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_3504_SAM >= 0 ? woCopy.num_3504_SAM : ""'
                      @input='woCopy.num_3504_SAM = Number($event); changes = true;' label='# of 3504 SAMs'
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='2'></v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy && woCopy.num_xeris >= 0 ? woCopy.num_xeris : ""'
                      @input='woCopy.num_xeris = Number($event); changes = true;' label="# xeris" :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_5004 >= 0 ? woCopy.num_5004 : ""'
                      @input='woCopy.num_5004 = Number($event); changes = true;' label="# of 5004s"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_5004_SAM >= 0 ? woCopy.num_5004_SAM : ""'
                      @input='woCopy.num_5004_SAM = Number($event); changes = true;' label='# of 5004 SAMs'
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='2'></v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy && woCopy.num_drip_emitters >= 0 ? woCopy.num_drip_emitters : ""'
                      @input='woCopy.num_drip_emitters = Number($event); changes = true;' label="# Drip Emitters"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy && woCopy.num_5012 >= 0 ? woCopy.num_5012 : ""'
                      @input='woCopy.num_5012 = Number($event); changes = true;' label="# of 5012s"
                      :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy && woCopy.num_zones >= 0 ? woCopy.num_zones : ""'
                      @input='woCopy.num_zones = Number($event); changes = true;' label="# zones" :rules='[rules.required, rules.int]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='5'></v-col>
                  <v-col cols='3'>
                    <v-text-field :value='woCopy ? woCopy.quarter_tubing : ""'
                      @input='woCopy.quarter_tubing = $event; changes = true;' label='1/4" tubing(feet)'
                      :rules='[rules.decimal]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy ? woCopy.three_quarter_poly : ""'
                      @input='woCopy.three_quarter_poly = $event; changes = true;' label='3/4" poly(# of rolls)'
                      :rules='[rules.decimal]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='4'>
                    <v-text-field :value='woCopy ? woCopy.one_inch_poly : ""'
                      @input='woCopy.one_inch_poly = $event; changes = true;' label='1" poly(# of rolls)'
                      :rules='[rules.decimal]'>
                    </v-text-field>
                  </v-col>
                  <v-col cols='3'>
                    <v-checkbox :value='woCopy ? woCopy.sys_supply_hosebib : false'
                      @change='woCopy.sys_supply_hosebib = $event === true; changes = true;'
                      label='System supplied by a hosebib?'></v-checkbox>
                  </v-col>
                  <v-col cols='3'>
                    <v-checkbox :value='woCopy ? woCopy.charged_line_to_hosebib : false'
                      @change='woCopy.charged_line_to_hosebib = $event === true; changes = true;'
                      label='Charged line to a hosebib?'></v-checkbox>
                  </v-col>
                  <v-col cols='3'>
                    <v-checkbox :value='woCopy ? woCopy.rain_sensor_installed : false'
                      @change='woCopy.rain_sensor_installed = $event === true; changes = true;'
                      label='Rain sensor installed?'></v-checkbox>
                  </v-col>
                  <v-col cols='3'></v-col>
                  <v-col cols='3'>
                    <v-checkbox :value='woCopy ? woCopy.charged_line_to_water : false'
                      @change='woCopy.charged_line_to_water = $event === true; changes = true;'
                      label='Charged line to water feature?'></v-checkbox>
                  </v-col>
                  <v-col cols='3'>
                    <v-checkbox :value='woCopy ? woCopy.labelled_rain_sensor_location : false'
                      @change='woCopy.labelled_rain_sensor_location = $event === true; changes = true;'
                      label='Labeled rain sensor location?'></v-checkbox>
                  </v-col>
                  <v-col cols='6'></v-col>
                  <v-col cols='6'>
                    <v-checkbox :value='woCopy ? woCopy.special_startup_required : false'
                      @change='woCopy.special_startup_required = $event === true; changes = true;'
                      label='Is there anything special to do at startup?'></v-checkbox>
                  </v-col>
                  <v-col cols='6'></v-col>
                  <v-col cols='12' v-if='woCopy.special_startup_required'>
                    <v-textarea :value='woCopy ? woCopy.special_startup_description : ""'
                      @input='woCopy.special_startup_description = $event; changes = true;'
                      label='Special SU Instructions' outlined
                      :rules='[rules.required]'>
                    </v-textarea>
                  </v-col>
                  <v-col cols='6'>
                    <v-checkbox :value='woCopy ? woCopy.special_blowdown_required : false'
                      @change='woCopy.special_blowdown_required = $event === true; changes = true;'
                      label='Is there anything special to do at the blowdown?'></v-checkbox>
                  </v-col>
                  <v-col cols='6'></v-col>
                  <v-col cols='12' v-if='woCopy.special_blowdown_required'>
                    <v-textarea :value='woCopy ? woCopy.special_blowdown_description : ""'
                      @input='woCopy.special_blowdown_description = $event; changes = true;'
                      label='Special BD Instructions' outlined
                      :rules='[rules.required]'>
                    </v-textarea>
                  </v-col>
                  <v-col cols='12'>
                    <v-textarea :value='woCopy ? woCopy.controller_location : ""'
                      @input='woCopy.controller_location = $event; changes = true;'
                      label='Where is the controller located?' outlined
                      :rules='[rules.required]'>
                    </v-textarea>
                  </v-col>
                  <v-col cols='6'>
                    <v-checkbox :value='woCopy ? woCopy.is_commercial : false'
                      @change='woCopy.is_commercial = $event === true; changes = true;'
                      label='Is this commercial?'></v-checkbox>
                  </v-col>
                  <v-col cols='6'></v-col>
                  <v-col cols='12' v-if='woCopy.is_commercial'>
                    <v-textarea :value='woCopy ? woCopy.shutoff_location : ""'
                      @input='woCopy.shutoff_location = $event; changes = true;' label='Where is the shutoff located?'
                      outlined :rules='[rules.required]'></v-textarea>
                  </v-col>
                  <v-col cols='12'>
                    <v-btn block class='mt-6' color='info' @click='saveForm' :disabled='!changes || !form_valid'>
                      Save Form
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </wc-data-box>
        </v-col>

        <!-- GEOLOCATOR -->
        <v-col cols='12' v-if="showGeolocator">
          <fc-geolocator :estimate='wo.estimate ? wo.estimate_obj : ""' :project='wo.project ? wo.project_obj : ""'
            @getUpdatedWO='getUpdatedWO'></fc-geolocator>
        </v-col>

        <!-- CONTACTS -->
        <v-col cols='12'>
          <fc-contacts v-if='wo' :wo='wo'></fc-contacts>
        </v-col>

        <!-- PREVIOUS CREW VISITS -->
        <v-col cols='12' v-if="crewVisits.length">
          <wc-data-box title='Previous Crew Visits' :titleIcon='$store.state.icons.dataBox.crewVisits.icon'
            :titleIconColor='$store.state.icons.dataBox.crewVisits.iconColor'>
            <template v-slot:toolbarButtons>
              <v-btn small depressed color='primary' width='76px' @click='showCrewVisits = !showCrewVisits'>
                <v-icon x-small class='mr-1'>{{ showCrewVisits ? 'mdi-arrow-expand-up' : 'mdi-arrow-expand-down'
                }}</v-icon>
                {{ showCrewVisits ? 'Hide' : 'Show' }}
              </v-btn>
            </template>
            <div v-if='showCrewVisits'>
              <template v-for='(v, index) in sortedVisits'>
                <v-divider v-if='index > 0' :key='v.id'></v-divider>
                <v-card flat :key="index + '-' + v.id">
                  <v-card-subtitle class='pb-2 d-flex align-baseline'>
                    <wc-avatar :profile='v.created_by_obj'></wc-avatar>
                    <span class='mx-2 heading-6'>{{ v.date | shortDate }}</span>
                    <small>{{ v.time | time }}</small>
                    <v-spacer></v-spacer>
                    <v-chip label class='mr-2' v-if='v.is_attempted' xSmall color='warning'>Attempted</v-chip>
                  </v-card-subtitle>
                  <v-card-text>
                    <span class='black--text'>{{ v.notes }}</span>
                  </v-card-text>
                </v-card>
              </template>
            </div>
          </wc-data-box>
        </v-col>

        <!-- MECHANICAL DETAILS (next on the list for it's own component) -->
        <!-- once broken out - need to add option for manual system selection - maybe (as per wo overview/mechanical) - MJ-->
        <v-col cols='12' v-if="woType.category === 'MC' && !isLoading">
          <wc-data-box title='Mechanical Details'>
            <v-card-text>
              <v-form v-model='isMechanicalFormValid' ref='mechanicalForm'>
                <v-textarea label='The shutoff is located...' outlined
                  :rules='[sentenceRules.noPeriod, sentenceRules.startLowercase]' hint='complete the sentence above'
                  persistent-hint v-model='projectDetailCopy.shutoff_location'></v-textarea>
                <v-textarea class='mt-6' label='The controller is located...' outlined
                  :rules='[sentenceRules.noPeriod, sentenceRules.startLowercase]' hint='complete the sentence above'
                  persistent-hint v-model='projectDetailCopy.controller_location'></v-textarea>
                <v-select class='mt-4' label='Controller Type' :items='controllers' item-text='description'
                  item-value='id' v-model='projectDetailCopy.controller'></v-select>
                <v-text-field class='mt-6' label='Flow Test' v-model='projectDetailCopy.flow_rate' outlined
                  :rules='[rules.int]' hint='Number of seconds it takes to fill a 5 gallon pail at 35 PSI'
                  persistent-hint></v-text-field>
                <v-textarea v-if='isMechanicalFormValid && projectDetailCopy.flow_rate > 42' label='Low Flow Notes'
                  outlined v-model='projectDetailCopy.low_flow_notes'
                  hint='please do another flow test at 30psi and record the results here' persistent-hint></v-textarea>
              </v-form>
              <v-btn block class='mt-6' color='info' :disabled='!isMechanicalFormValid' @click='saveProjectDetail'>
                Save All
              </v-btn>
            </v-card-text>
          </wc-data-box>
        </v-col>

        <!-- FLOW TEST -->
        <!-- should this be rolled into generic wo data table? -->
        <v-col cols='12' v-if="woType.category === 'IN'">
          <wc-data-box title='Max Design Volume' titleIcon='mdi-water-alert' titleIconColor='primary'>
            <v-card-text class='py-2'>
              <span class='font-weight-bold mr-2'>
                {{ ((5 / (wo.project_obj.project_detail.flow_rate / 60)) * .9).toFixed(1) + " GPM (35psi)" }}
              </span>
            </v-card-text>
            <v-card-text v-if='wo.project_obj.project_detail.low_flow_notes' class='py-2'>
              <span class='font-weight-bold error--text'>Low Flow Notes:</span><br>
              <span class='black--text'>{{ wo.project_obj.project_detail.low_flow_notes }}</span>
            </v-card-text>
          </wc-data-box>
        </v-col>

        <!-- COMPLETED BUTTONS -->
        <v-col cols='12'>
          <v-btn block depressed color='warning' :disabled='wo.is_complete || wo.left' @click='stopTimer()'>
            Stop Timer
          </v-btn>
        </v-col>
        <v-col cols='12'>
          <v-btn block depressed color='success' @click='showAuthorizationDialog = true'
            v-if="wo.wo_type_obj.category === 'SH'">
            Authorizations
          </v-btn>
        </v-col>
        <v-col cols='12'>
          <v-btn block depressed color='teal' style="color: white;" @click='open_send_show = true'
            v-if="wo.wo_type_obj.category === 'SH'">
            Send Show Documents
          </v-btn>
        </v-col>

        <v-col cols='12'>
          <v-btn block depressed color='primary'
            :disabled='wo.is_complete || (wo.arrived && !wo.left) || !form_complete' @click='showConfirm = true'>
            No issues remain - Complete
          </v-btn>
        </v-col>

        <v-col cols='12'>
          <v-btn block depressed color='error' @click='couldNotComplete()' :disabled="wo.arrived && !wo.left">
            Could not complete
          </v-btn>
        </v-col>

      </v-row>
      <wc-page-section class='mt-n7' title='Files'></wc-page-section>
      <v-row style="padding-bottom: 150px;">
        <v-col cols='12' md='12'>
          <wo-files v-if="wo" :files='wo.work_order_file_data' :work_order_id='wo.id'></wo-files>
        </v-col>
      </v-row>
    </v-container>

    <wc-dialog :showDialog='showIssueDialog' title='Could Not Complete' :disableButtons='!isIssueFormValid'
      :loadingButtons='isSaving' @cancel='showIssueDialog = false' @save='completeWO(false)' width='350'>
      <v-form ref='issue' v-model='isIssueFormValid' :disabled='isSaving'>
        <v-row>
          <v-col cols='12'>
            <v-textarea :auto-grow='true' ref='reason' v-model='couldNotCompleteNotes'
              label="Reason you couldn't complete" :rules='[rules.required]' outlined
              hint='Be descriptive so next crew understands the situation' persistent-hint></v-textarea>
          </v-col>

          <v-col cols='5' v-if="woType.category === 'SU'">
            <v-btn block elevation='0' color='primary' @click='appendNote("Water Still Off")'>Water Off</v-btn>
          </v-col>

          <v-col cols='5' v-if="woType.category === 'BD'">
            <v-btn block elevation='0' color='primary' @click='appendNote("Water Still On")'>Water On</v-btn>
          </v-col>

          <v-col cols='5' v-if="woType.category === 'SU' || woType.category === 'BD'">
            <v-btn block elevation='0' color='primary' @click='appendNote("The gates are locked")'>Locked gates</v-btn>
          </v-col>
          <span class='caption ml-3'>clicking a button will append the note</span>
        </v-row>
      </v-form>
    </wc-dialog>

    <wc-dialog title='Complete Work Order?' :showDialog='showConfirm' :disableButtons='!isFormValid'
      :loadingButtons='isSaving' saveText='Confirm' @cancel='showConfirm = false' @save='completeWO(true)'
      :loading='isSaving' width='350'>
      <span>Are you sure you want to mark this site as complete?</span>
      <br>
      <div v-if='woType.category === "BD" || woType.category === "SU"'>
        <span class='caption font-italics'>An email will be automatically sent to the customer</span>
      </div>
      <br>
      <strong class='primary--text'>
        {{ wo.project ? wo.project_obj.name : wo.estimate_obj.name }}<br>
        {{ wo.project ? wo.project_obj.site_address : wo.estimate_obj.site_address }}
      </strong>
      <v-form v-model='isFormValid' ref='form'>
        <!-- NEW INSTALL CHECKS -->
        <fc-install-check-form v-if='woType.category === "IN"' v-model='installChecks'></fc-install-check-form>
        <!-- insert Mechanical checks here when available -->
      </v-form>

      <!-- MECHANICAL WO FINAL CHECKS. -->

      <!-- Call office if low flow, check there are low flow notes -->
      <!-- if flow > 42, low_flow_notes must have a value.  Did you do another flow test at 30psi and 25psi -->
      <!-- conditional based on date - did you leave the water turned off? -->
      <!-- Have you checked that the geolocation is accurate? -->
      <!-- Did you install wifi module -->

      <!-- probably best if this comes up only conditionally - if there's stuff the worker could have missed -->
      <!-- field crew doesn't even read this when it pops up every time  -->
    </wc-dialog>

    <wc-confirm :showDialog='authorizationConfirm' @cancel='authorizationConfirm = false;' @confirm='confirmAuthChange'>
      Whoa there, wait a minute! Changing this setting can have some pretty dire consequences.<br>
      <br>
      If staging for SU/BD has already begun make sure to <strong>FIND THE SYSTEM IN STAGING AND DO THE APPROPRIATE
        ACTION
        TO THE SYSTEM FOR THIS YEAR.</strong><br>
      <br>
      (Changing it here will affect long term but for this year you will also need to move the system where you want it
      to
      be in staging. Example: If you are changing a system from “no work required” to “authorized” you will need to find
      it
      in the cancelled section and un-cancel this year as well.)<br>
      <br>
      Please make sure you REALLY want to change this!<br>
    </wc-confirm>
    <wc-dialog :showDialog='showActionDialog' title='Action' icon='mdi-message-text'
      @cancel='showActionDialog = false; showConfirm = false; showDialog = false;' @save='saveAction'
      :disableButtons='!isActionFormValid'>
      <v-form v-model='isActionFormValid' ref='actionForm'>
        <v-textarea label='Please specify a reason for making this change' v-model='actionDescription'
          :rules='[rules.required]' outlined></v-textarea>
      </v-form>
    </wc-dialog>


    <wc-dialog :showDialog='showAuthorizationDialog' title='Authorizations' icon='mdi-checkbox-marked-circle-outline'
      @cancel='showAuthorizationDialog = false' @save='saveProjectDetail' width='400'>
      <v-form v-model='isFormValid'>
        <v-checkbox hide-details v-model='projectDetailCopy.no_work_required' label='No Work Required'
          @change="setupChange('nwr')"></v-checkbox>
        <v-checkbox hide-details v-model='projectDetailCopy.su_authorized' label='Ongoing SU Authorized'
          @change="setupChange('sua')"></v-checkbox>
        <v-checkbox hide-details v-model='projectDetailCopy.bd_authorized' label='Ongoing BD Authorized'
          @change="setupChange('bda')"></v-checkbox>
        <v-checkbox v-if='wo.project_obj.is_comm' hide-details v-model='projectDetailCopy.post_sept_bd'
          label='BD PS20?'></v-checkbox>
        <v-checkbox :disabled='wo.project_obj.is_comm' v-model='projectDetailCopy.can_have_bm8'
          label='Can this system have BM8/ES10 option?' :persistent-hint='wo.project_obj.is_comm'
          :hint='wo.project_obj.is_comm ? "Commercial Projects cannot have the BM8/ES10 option" : ""'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.needs_key' label='Is a key needed for the SU/BD?'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.needs_po' label='Is a PO needed for the SU/BD?'></v-checkbox>
      </v-form>
    </wc-dialog>
    <wc-dialog title='Send Show Documents' :showDialog='open_send_show' :loadingButtons='false'
      :body_text="`<p>Are you sure you want to send the show documents?</p>`" saveText='Confirm'
      @cancel='open_send_show = false' @save='sendShowDocuments()' width='350' />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import WorkOrderFiles from '@/components/files/WorkOrderFiles';
import irrigationAPI from '@/modules/irrigation/api/irrigations';
import projectAPI from '@/api/project';
import trackerAPI from "@/api/tracker";
import OutstandingService from '@/modules/projects/components/OutstandingService';
import formRules from '@/mixins/formRules';
import wosAPI from '@/modules/wos/api';
import wosAPINew from "@/api/work_orders";
import FCAlertBanners from './FCAlertBanners';
import FCContacts from './FCContacts';
import FCProduct from './FCProduct';
import FCLabour from './FCLabour';
import FCStickies from './FCStickies';
import FCGeolocator from './FCGeolocator';
import FCInstallCheckForm from './FCInstallCheckForm';

export default {
  name: 'irrigation-WOcard-detail-overview',
  mixins: [formRules],
  props: {
    wo: {
      required: true
    },
    woType: {
      required: true
    },
    crewVisits: {
      required: true
    },
    productList: {
      required: true
    },
    product: {
      required: true
    },
    labour: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: true,
    form_valid: false,
    installChecks: "",
    changes: false,
    isMechanicalFormValid: true,
    isIssueFormValid: false,
    showDetails: false,
    showCrewVisits: true,
    woCopy: {},
    showAuthorizationDialog: false,
    projectDetailCopy: {},
    projectCopy: {},
    notes: [],
    suNote: '',
    bdNote: '',
    loadingNotes: false,
    controllers: [],
    issueCopy: {},
    couldNotCompleteNotes: '',
    showIssueDialog: false,
    showConfirm: false,
    authorizationConfirm: false,
    showActionDialog: false,
    isActionFormValid: false,
    actionDescription: '',
    action: '',
    changeDescription: '',
    label: 'grey--text text--darken-2 text-left text-no-wrap',
    dataValue: 'text-right pt-2 px-2',
    open_send_show: false
  }),
  mounted() {
    this.setupData();
  },
  watch: {
    'showConfirm'() {
      if (this.showConfirm) {
        this.$nextTick(() => {
          this.$refs.form.reset()
        })
      }
    }
  },
  computed: {
    // keep this list in order of how components appear up top
    // showFiles () { return _.includes(['SV','SU','BD','MC','IN','ES'], this.woType.category) },
    form_complete() {
      if (this.woType.category !== "IN") {
        return true;
      }

      if (this.wo.asbuilt_completed_by === "") {
        return false;
      }
      if (this.wo.num_1802 < 0) {
        return false;
      }
      if (this.wo.num_1804 < 0) {
        return false;
      }
      if (this.wo.num_1804_SAM < 0) {
        return false;
      }
      if (this.wo.num_1812 < 0) {
        return false;
      }
      if (this.wo.num_3504 < 0) {
        return false;
      }
      if (this.wo.num_3504_SAM < 0) {
        return false;
      }
      if (this.wo.num_5004 < 0) {
        return false;
      }
      if (this.wo.num_5004_SAM < 0) {
        return false;
      }
      if (this.wo.num_5012 < 0) {
        return false;
      }
      if (this.wo.quarter_tubing === "") {
        return false;
      }
      if (this.wo.three_quarter_poly === "") {
        return false;
      }
      if (this.wo.one_inch_poly === "") {
        return false;
      }
      if (this.wo.num_shrubrisers < 0) {
        return false;
      }
      if (this.wo.num_shrubblers < 0) {
        return false;
      }
      if (this.wo.num_xeris < 0) {
        return false;
      }
      if (this.wo.num_zones < 0) {
        return false;
      }
      if (this.wo.special_blowdown_required && this.wo.special_blowdown_description === "") {
        return false;
      }
      if (this.wo.special_startup_required && this.wo.special_startup_description === "") {
        return false;
      }
      if (this.wo.controller_location === "") {
        return false;
      }
      if (this.wo.is_commercial && this.wo.shutoff_location === "") {
        return false;
      }
      return true;
    },
    showFiles() { return true },
    showGeolocator() { return _.includes(['MC', 'SH', 'FU', 'ES', 'SV', 'IN'], this.woType.category) },
    showProductPicker() { return _.includes(['SV', 'SU', 'BD', 'SH'], this.woType.category) },
    showLabourPicker() { return _.includes(['SV', 'SU', 'BD', 'SC', 'SH'], this.woType.category) },

    sortedVisits() {
      return _.orderBy(this.crewVisits, ['date', 'time'], ['desc', 'desc'])
    },
    woData() {
      let table = [
        { text: 'Problem Description:', value: this.wo.problem_description ? this.wo.problem_description : '' },
      ]
      if (this.wo.instructions) {
        table.push({ text: 'Instructions:', value: this.wo.instructions })
      }
      if (this.wo.project && this.wo.project_obj.field_instructions) {
        table.push({ text: 'Notes to Crew:', value: this.wo.project_obj.field_instructions })
      }
      if (this.woType.category === 'BD') {
        table.push({ text: 'BD Instructions:', value: this.wo.project_obj.project_detail.bd_instr_perm_field })
      }
      if (this.woType.category === 'BD' && !!this.bdNote.length) {
        table.push({ text: 'One Time BD Note:', value: this.bdNote[0].note, class: 'red--text' })
      }
      if (this.woType.category === 'SU') {
        table.push({ text: 'SU Instructions:', value: this.wo.project_obj.project_detail.su_instr_perm_field })
      }
      if (this.woType.category === 'SU' && !!this.suNote.length) {
        table.push({ text: 'One Time SU Note:', value: this.suNote[0].note, class: 'red--text' })
      }
      if (this.woType.category === 'SH' || this.woType.category === 'FU') {
        table.push({ text: 'SU Price:', value: this.wo.project_obj.project_detail.subd_tier ? this.$options.filters.intMoney(this.wo.project_obj.project_detail.subd_tier_obj.su_price) : "(Not Set)" })
        table.push({ text: 'BD Price:', value: this.wo.project_obj.project_detail.subd_tier ? this.$options.filters.intMoney(this.wo.project_obj.project_detail.subd_tier_obj.bd_price) : "(Not Set)" })
      }
      return table
    },
    siteDetails() {
      let table = [
        { text: this.wo.project_obj.project_detail.is_capital_system ? 'Install Date:' : 'Takeover Date:', value: this.$options.filters.shortDate(this.wo.project_obj.project_detail.install_date) },
        { text: 'Zones:', value: this.wo.project_obj.project_detail.num_zones },
        { text: 'Hose Bib Supply: ', value: this.$options.filters.trueFalse(this.wo.project_obj.project_detail.is_hose_bib), class: this.wo.project_obj.project_detail.is_hose_bib ? "red--text" : "" },
        { text: 'Charged Hose bib(s): ', value: this.$options.filters.trueFalse(this.wo.project_obj.project_detail.has_charged_hose_bib), class: this.wo.project_obj.project_detail.has_charged_hose_bib ? "red--text" : "" },
        { text: 'Charged Water Feature(s): ', value: this.$options.filters.trueFalse(this.wo.project_obj.project_detail.has_charged_feature), class: this.wo.project_obj.project_detail.has_charged_feature ? "red--text" : "" },
        { text: "Controller Type: ", value: this.wo.project_obj.project_detail.controller_obj ? this.wo.project_obj.project_detail.controller_obj.description : "", class: "" },
        { text: "Controller Location: ", value: this.wo.project_obj.project_detail.controller_location, class: "" },
        { text: "Shutoff Location: ", value: this.wo.project_obj.project_detail.shutoff_location, class: "" },
      ]
      return table
    },
    today() {
      return moment().format('YYYY-MM-DD').toString()
    },
    year() {
      return parseInt(moment().format('YYYY'))
    },
    sentenceRules() {
      return {
        noPeriod: (value) => {
          const pattern = /^[^.]+$|null|^\s*$/
          return pattern.test(value) || 'cannot contain or end with a period'
        },
        startLowercase: (value) => {
          const pattern = /^([a-z])|^(?![\s\S])/
          return pattern.test(value) || 'must start with lowercase letter'
        },
      }
    }
  },
  methods: {
    async notifyArrival() {
      const time = moment().format('YYYY-MM-DDTHH:mm:ss').toString();
      const response = await wosAPINew.updateWO({ "start_time": time, "arrived": true, "id": this.wo.id });
      this.$emit("updateWO", response);
    },
    async saveForm() {
      if (!this.$refs.form.validate()) return;
      await wosAPINew.updateWO({ ...this.woCopy, "id": this.wo.id });
      this.changes = false;
    },
    async saveWO() {
      await wosAPINew.updateWO({ ...this.woCopy, "id": this.wo.id });
    },
    async stopTimer() {
      const time = moment().format('YYYY-MM-DDTHH:mm:ss').toString();
      const response = await wosAPINew.updateWO({ "end_time": time, "left": true, "id": this.wo.id });
      this.$emit("updateWO", response);
    },
    async setupData() {
      this.isLoading = true;
      this.woCopy = this.wo;
      if (this.wo.project) {
        this.projectDetailCopy = _.cloneDeep(this.wo.project_obj.project_detail)
        this.projectCopy = _.cloneDeep(this.wo.project_obj)
      }
      if (this.woType.category === 'MC') {
        this.controllers = await irrigationAPI.getControllers()
      }
      if (this.wo.project && this.wo.project_obj.division_obj.division === 'Irrigation') {
        let notes = await irrigationAPI.getOneTimeNotes(this.wo.project_obj.id)
        this.suNote = _.filter(notes, { 'note_year': this.year, 'is_su_note': true, 'note_type': 'F' })
        this.bdNote = _.filter(notes, { 'note_year': this.year, 'is_su_note': false, 'note_type': 'F' })
      }
      if (this.wo.project && (this.wo.project_obj.project_detail.is_hose_bib || this.wo.project_obj.project_detail.has_charged_hose_bib || this.wo.project_obj.project_detail.has_charged_feature)) {
        this.showDetails = true
      }
      this.isLoading = false
    },
    async completeWO(isComplete) {
      this.isSaving = true;
      this.woCopy = _.cloneDeep(this.wo);
      let newVisit = {
        work_order: this.woCopy.id,
        created_by: this.$store.state.auth.profile.id,
      }
      if (!isComplete) {
        this.isSaving = true
        this.woCopy.is_complete = false
        this.woCopy.date_completed = null
        this.woCopy.is_attempted = true
        newVisit.notes = this.couldNotCompleteNotes
        newVisit.is_attempted = true
        this.isSaving = false
        this.showIssueDialog = false
        this.$emit('couldntCompleteWO', this.woCopy);
      } else {
        this.woCopy.is_complete = true
        this.woCopy.date_completed = this.today
        this.woCopy.is_attempted = false
        newVisit.notes = 'Work order completed'
        newVisit.is_attempted = false
        this.isSaving = false
        this.showConfirm = false
        this.$emit('completeWO', this.woCopy);
        if (this.woType.category === "IN") { await this.createInstallSticky() }
      }
      await wosAPI.createCrewVisitForWO(newVisit);
    },
    getUpdatedWO() {
      this.$emit('getUpdatedWO')
    },
    updateProduct(prod) {
      this.$emit('updateProduct', prod)
    },
    updateLabour(labour) {
      this.$emit('updateLabour', labour)
    },
    deleteLabour(labourID) {
      this.$emit('deleteLabour', labourID)
    },
    couldNotComplete() {
      this.showIssueDialog = true
      setTimeout(() => {
        this.$refs.issue.resetValidation()
      }, 50)
      setTimeout(() => {
        this.$refs.reason.focus()
      }, 100)
    },
    saveProjectDetail() {
      irrigationAPI.updateIrrigationProject(this.projectDetailCopy)
      projectAPI.updateProject(this.projectCopy.id, this.projectCopy);
      this.showAuthorizationDialog = false;
    },
    appendNote(note) {
      this.couldNotCompleteNotes = this.couldNotCompleteNotes + note + '\r\n'
    },
    async createInstallSticky() {
      this.$refs.stickies.resetSticky()
      this.$refs.stickies.stickyCopy.description = this.installChecks
      await this.$refs.stickies.saveSticky()
    },
    async sendShowDocuments() {
      this.open_send_show = false;
      await wosAPI.sendShowDocuments(this.wo.id);
      this.wo.show_documents_sent = true;
    },
    setupChange(val) {

      console.log(JSON.parse(JSON.stringify(this.projectDetailCopy)));

      /*
      nwr --> NWR was clicked
      sua --> SU Auth was clicked
      bda --> BD Auth was clicked
      */
      if (val === 'nwr') {
        if (this.projectDetailCopy.no_work_required) {
          this.projectDetailCopy.su_authorized = false;
          this.projectDetailCopy.bd_authorized = false;
          this.changeDescription = "NWR was turned on";
        }
        else {
          this.changeDescription = "NWR was turned off";
        }
      }
      else if (val === 'sua') {
        this.projectDetailCopy.no_work_required = false;
        if (this.projectDetailCopy.su_authorized) {
          this.changeDescription = "SU Authorized was turned on";
        }
        else {
          this.changeDescription = "SU Authorized was turned off";
        }
      }
      else if (val === "bda") {
        this.projectDetailCopy.no_work_required = false
        if (this.projectDetailCopy.bd_authorized) {
          this.changeDescription = "BD Authorized was turned on";
        }
        else {
          this.changeDescription = "BD Authorized was turned off";
        }
      }
      this.authorizationConfirm = true;
    },
    confirmAuthChange() {
      if (this.projectDetailCopy.no_work_required) {
        this.projectDetailCopy.su_authorized = false
        this.projectDetailCopy.bd_authorized = false
      }
      this.showActionDialog = true
    },
    async saveAction() {
      console.log(this.changeDescription)
      const tracker_data = {
        'description': this.actionDescription,
        'action': this.changeDescription,
        'taken_by': this.$store.state.auth.profile.id,
        'action_date': moment().format('YYYY-MM-DD').toString(),
      }
      const tracker = {
        'tracker_data': tracker_data,
        'project': this.projectCopy.id
      };
      await trackerAPI.createProjectTracker(tracker);
      this.showActionDialog = false;
      this.authorizationConfirm = false;
    },
  },
  components: {
    'fc-alert-banners': FCAlertBanners,
    'wo-files': WorkOrderFiles,
    'fc-contacts': FCContacts,
    'fc-product': FCProduct,
    'fc-labour': FCLabour,
    'fc-stickies': FCStickies,
    'fc-geolocator': FCGeolocator,
    'fc-install-check-form': FCInstallCheckForm,
    'outstanding-service': OutstandingService
  },
}
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
  /* this allows v-html table data to vertical-align properly */
}
</style>
